const googleTagManagerDataLayer = (() => {
    if (typeof window === 'undefined') {
        return []
    }

    return (window._gtm ??= [])
})()

// Needs to be in a separate file (workaround for tests)
export function publishGoogleTagManagerEvents(events: GoogleTagManagerEvents): void {
    events.forEach(({ context, ...event }) => {
        googleTagManagerDataLayer.push({
            ...event,
            ...(context as Record<string, unknown>),
        })
    })
}
